<template>
  <div :class="$style.boxLogin">
    <transition name="process-fade">
      <div :class="$style.loginProcess" v-show="loginVisible">
        <div :class="$style.content">
          <div :class="$style.state">
            <img :src="`//sdk-static.zhangyuqu.com/Lianyun/font_end/boxSdk/loading.png`" alt="" :class="$style.loading" />
            <span>{{loginText}}</span>
          </div>
        </div>
      </div>
    </transition>
    <!-- 防沉迷 -->
    <AntiIndulged v-if="userState.antiIndulgedVisible" @toLogin="antiIndulgedLogin"></AntiIndulged>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { registJSInitial, registLoginVerifySuccessFunction, boxLoginFail2Sdk, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { activityLink, FLOAT_URL, vipPushLink } from '@/config';
import AntiIndulged from './anitiIndulged/antiIndulgedLogin.vue';

export default {
  data() {
    return {
      notifyInfo: {}, // 登录后传给客户端的信息
      loginVisible: false,
      loginText: '登录中...'
    };
  },
  created() {},
  mounted() {
    this._clientInit();
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      globalState: (state) => state.global,
    }),
  },

  components: {
    AntiIndulged,
  },
  methods: {
    _clientInit() {
      this.loginVisible = true;
      this.loginText = '初始化中...'
      registJSInitial(async (e, cb) => {
        const _data = JSON.parse(e);
        // 记录下当前游戏为盒子类型游戏
        if (_data.is_wx_box_game) {
          this.$setStorage('game_type', 'wxBoxGame');
        } else {
          this.$setStorage('game_type', 'boxGame');
        }
        this.$store.commit('user/CHANGE_STATE', {
          device_info: _data.attributeReportParams,
          appkey: _data.jh_app_id,
          channel: _data.jh_channel,
          extra_data: JSON.stringify(_data.extra_data),
          game_version: _data.game_version,
          sdk_version: _data.sdk_version,
          third_sdk_status: _data.third_sdk_status || '', // 这里一定要 || '' ，否则缓存可能存undefined导致支付页出问题
        });
        // 缓存state
        const cacheList = ['sdk_version', 'device_info', 'appkey', 'channel', 'extra_data', 'game_version', 'third_sdk_status'];
        await this.$store.dispatch('user/cacheState', cacheList);
        await this.$store.dispatch('user/getYsdkStatus');
        this.btLogin(_data.box_code);
      });
    },
    async btLogin(code) {
      this.loginText = '登录中...'
      try {
        await this.$store.dispatch('user/btLogin', code);
        this.loginVisible = false;
        this.handleLoginInfo();      
      } catch (error) {
        this.loginVisible = false;
        boxLoginFail2Sdk(null)
        skipWXBox2Sdk({
          event: 'boxLoginFail',
          syAppkey: '',
          boxUrl: '',
          routePath: ""
        })
      }
    },
    // 继续处理登录接口返回信息（强制绑定手机成功后也要调用）
    async handleLoginInfo() {
      // vip检查
      await this.$store.dispatch('user/checkVip');
      // 处理登录后通知客户端的信息
      await this.handleNotifyInfo();
      // 防沉迷判断
      this.$store
        .dispatch('user/checkAntiIndulged')
        .then(() => {
          this.$store.commit('user/CHANGE_STATE', {
            antiIndulgedVisible: true,
          });
          this.$store.commit('global/clearLoading');
        })
        .catch(() => this.notifyLoginSuccess());
    },
    // 处理要通知客户端的信息
    async handleNotifyInfo() {
      const { is_vip, vip_type } = this.userState;
      this.notifyInfo = {
        session_id: this.userState.session_id,
        user_id: this.userState.user_id,
        user_name: this.userState.username,
        password: this.userState.password,
        ios_password: this.userState.password,
        login_flag: 1, // 无意义，但不传安卓会报错
        bind_flag: 0, // 无意义，但不传安卓会报错
        bind_status: this.userState.tel_status == 0 ? 1 : 0,
        access_token: this.userState.access_token,
        id_card_status: this.userState.id_card_status,
        force_bind_tel: this.userState.force_bind_tel,
        register_time: this.userState.register_time,
        is_open_activity_url: false, // 已经不用的活动字段，暂存防止客户端异常
        activity_url: '', // 已经不用的活动字段，暂存防止客户端异常
        is_vip: this.userState.is_vip,
        vip_push: vip_type == 2 && is_vip ? vipPushLink : '',
        float_url: FLOAT_URL,
        activityLink,
        menu_list: [], // 安卓兼容处理
        update_gift_url: this.userState.update_gift_status === 1 ? `${window.location.origin}/h5sdk/update-gift` : '',
      };
    },
    // 通知客户端登录成功
    async notifyLoginSuccess() {
      console.log('--------通知客户端登录成功调用-------')
      registLoginVerifySuccessFunction(this.notifyInfo);
    },
    // 防沉迷实名认证后通知客户端登录成功
    antiIndulgedLogin(anti_indulged_info) {
      this.notifyInfo = {
        ...this.notifyInfo,
        anti_indulged_info, // 安卓旧sdk用
        anti_indulged_url: `${window.location.origin}/h5sdk/client/antiIndulged`, // 安卓新sdk用
      };
      registLoginVerifySuccessFunction(this.notifyInfo);
    },
  },
};
</script>
<style lang="scss">

.process-fade-enter,
.process-fade-leave-to {
  transform: translate3d(0, -92px, 0);
}

.process-fade-enter-to,
.process-fade-leave {
  transform: translate3d(0, 0, 0);
}

.process-fade-enter-active,
.process-fade-leave-active {
  transition: all 500ms linear;
}
</style>
<style lang="scss" module>
.boxLogin {
  width: 100%;
  height: 100%;
  .loginProcess {
    background: #ffffff;
    width: 100px;
    height: 38px;
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 6px;
    display: flex;
    align-items: center;
    background: #ff3b36;
    perspective: 1000px;
    padding: 10px;
    > .content {
      color: #ffffff;
      text-align: center;
      > .state {
        color: #ffffff;
        font-size: 13px;
        display: flex;
        justify-content: center;
        align-content: center;
        .loading {
          width: 11px;
          height: 11px;
          margin-right: 6px;
          animation: loading 1.5s infinite linear;
        }
      }
    }
  }
  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
